export default "__VITE_ASSET__26b33f22__"